/// <amd-module name="Pipeline/Analytics/PipelineOutcome/FailingTaskGrid/Actions/PipelineOutcomeFailingTaskGridActionsCreator" />
import { IReportContext } from "Analytics/Shared/Common/Types";
import { IPipelineOutcomeReportConfiguration } from "Pipeline/Analytics/Common/Types";
import { PipelineOutcomeFailingTaskGridActions } from "Pipeline/Analytics/PipelineOutcome/FailingTaskGrid/Actions/PipelineOutcomeFailingTaskGridActions";
import { PipelineOutcomeFailingTaskGridSource } from "Pipeline/Analytics/PipelineOutcome/FailingTaskGrid/Sources/PipelineOutcomeFailingTaskGridSource";
import { IVssPageContext } from "VSS/Platform/Context";

export class PipelineOutcomeFailingTaskGridActionsCreator {
    private _pipelineOutcomeFailingTaskGridSource: PipelineOutcomeFailingTaskGridSource;
    constructor(private _actions: PipelineOutcomeFailingTaskGridActions, private _pageContext: IVssPageContext) {
        this._pipelineOutcomeFailingTaskGridSource = new PipelineOutcomeFailingTaskGridSource(_pageContext);
    }

    public updateConfigurationValues(reportContext: IReportContext, newConfValues: IPipelineOutcomeReportConfiguration): Promise<void> {
        this._actions.updateConfigurationValuesAction.invoke(newConfValues);
        return this.updateFailingTaskGridData(reportContext, newConfValues);
    }

    private async updateFailingTaskGridData(reportContext: IReportContext, confValues: IPipelineOutcomeReportConfiguration): Promise<void> {
        try {
            const failingTaskGridData = await this._pipelineOutcomeFailingTaskGridSource.queryPipelineOutcomeFailingTasks(
                reportContext,
                confValues
            );

            this._actions.updateDataAction.invoke(failingTaskGridData);
        } catch (error) {
            this._actions.onError.invoke(error);
            return Promise.reject(error);
        }
    }
}
